angular.module('gym.components').directive('signedWaiverContacts', function() {
  return {
    restrict: 'EA',
    scope: {
      waiver: '=',
      currency: '='
    },
    template: require('templates/components/waivers/signed_waiver_contacts.html.slim'),
    controller: ["$scope", function($scope) {
      $scope.displayMemberNumber = function(contact) {
        var signed_waiver;
        signed_waiver = $scope.waiver.signed_waiver_form_attributes;
        return signed_waiver.accept_member_number && contact.attending;
      };
      return $scope.isFieldAvailable = function(field) {
        return $scope.waiver.signed_waiver_form_attributes.required_fields[field] !== 'hidden';
      };
    }]
  };
});
